import { render } from "./Register.vue?vue&type=template&id=21809f55"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=21809f55&lang=scss"
import "./Register.vue?vue&type=style&index=1&id=21809f55&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\model-project-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__